var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Dailymotion = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.playingAds) return this.lastPlayhead
    this.lastPlayhead = this.player.currentTime
    return this.lastPlayhead
  },

  /** Override to return current playrate */
  /*getPlayrate: function() {
    return null
  },*/

  /** Override to return video duration */
  getDuration: function () {
    if (isNaN(this.player.duration)) return null
    return this.player.duration
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.player.quality
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.video.title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return false
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.src
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Dailymotion'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [null,
      'ad_end',
      'ad_pause',
      'ad_play',
      'ad_start',
      //'ad_timeupdate',
      'apiready',
      'controlschange',
      'durationchange',
      'end',
      'ended',
      'error',
      'fullscreenchange',
      'loadedmetadata',
      'pause',
      'play',
      'playing',
      'progress',
      'qualitiesavailable',
      'seeked',
      'seeking',
      'subtitlechange',
      'subtitlesavailable',
      'start',
      //'timeupdate',
      'video_start',
      'video_end'
    ])

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references['start'] = this.startListener.bind(this)
    this.references['play'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['seeked'] = this.seekedListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)
    this.references['apiready'] = this.registerAdsListener.bind(this)
    this.references['timeupdate'] = this.timeupdateListener.bind(this)

    this.references['ad_start'] = this.adStartListener.bind(this)
    this.references['ad_end'] = this.adEndListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },
  startListener: function (e) {
    this.fireStop()
    this.fireStart()
  },

  registerAdsListener: function (e) {
    var adapter = new youbora.adapters.Dailymotion.GenericAdsAdapter(this.player)
    this.plugin.setAdsAdapter(adapter)
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireStart()
    this.fireResume()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    if (this.player.error) {
      this.fireError(this.player.error.code + ' ' + this.player.error.title, this.player.error.message)
      this.fireStop()
    } else {
      this.fireError()
    }
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
    this.lastPlayhead = 0
  },

  adStartListener: function () {
    this.playingAds = true
  },
  adEndListener: function () {
    this.playingAds = false
  },

  timeupdateListener: function () {
    if (!this.flags.isStarted) {
      this.fireStart()
      if (!this.playingAds) this.fireJoin()
    }
  }
}, {
    GenericAdsAdapter: require('./ads/native')
  })

module.exports = youbora.adapters.Dailymotion
